var DealsPaginationEventsHelper, DealsPaginationFooterView, PaginatedDealsListTemplate, PaginatedDealsListView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsPaginationFooterView = require('./pagination_footer');

DealsPaginationEventsHelper = require('../helpers/pagination_events');

PaginatedDealsListTemplate = require('../../paginated_deals_list.html.mustache');

module.exports = PaginatedDealsListView = (function() {
  PaginatedDealsListView.prototype.template = PaginatedDealsListTemplate;

  PaginatedDealsListView.prototype.dealsListId = 'browse-deals';

  function PaginatedDealsListView($el, dealSearch) {
    var currentSearchPage, ref;
    this.$el = $el;
    this.dealSearch = dealSearch;
    this.searchError = bind(this.searchError, this);
    this.searchSuccess = bind(this.searchSuccess, this);
    this.$content = this.$el.find('.content');
    this.prevSearch = null;
    this.footer = new DealsPaginationFooterView();
    this.footer.on('click:paginationLink', this.paginationClickHandler);
    currentSearchPage = (ref = this.dealSearch.params.page) != null ? ref : 1;
    window.onpopstate = _.partial(DealsPaginationEventsHelper.popStateHandler, currentSearchPage);
  }

  PaginatedDealsListView.prototype.render = function() {
    if (this.dealSearch.isEmptySearch()) {
      return;
    }
    this.$content.html(this.toHtml());
    this.postRender();
    return Groupon.BrowseTracking.pageReady();
  };

  PaginatedDealsListView.prototype.postRender = function(overwriteExisting) {
    var element, options;
    if (overwriteExisting == null) {
      overwriteExisting = true;
    }
    this.footer.updatePresenter(this.dealSearch).setElement(this.$el.find('.pagination_footer'));
    if (overwriteExisting) {
      this.footer.render();
    }
    GIG.Utils.truncateElements(element = this.$content, options = {
      watch: false
    });
    return GIG.Tooltip.reloadBindings(element = this.$content, false);
  };

  PaginatedDealsListView.prototype.toHtml = function() {
    return this.template.render(this.present());
  };

  PaginatedDealsListView.prototype.present = function() {
    var hash;
    hash = _.extend({}, this.dealSearch.page, {
      dealsListId: this.dealsListId,
      columnLayoutClass: Groupon.columnLayoutClass,
      cardUIClass: Groupon.cardUIClass
    });
    return hash;
  };

  PaginatedDealsListView.prototype.searchSuccess = function() {
    this.$content.find("#" + this.dealsListId).append(this.dealSearch.page.dealsHtml);
    return this.postRender();
  };

  PaginatedDealsListView.prototype.searchError = function() {
    this.dealSearch = this.prevSearch;
    this.footer.removeLoadingState();
    return this.$el.find('.pagination_footer').remove();
  };

  PaginatedDealsListView.prototype.paginationClickHandler = function(event) {
    return DealsPaginationEventsHelper.updatePageByHref(event.target.href);
  };

  return PaginatedDealsListView;

})();

//# sourceMappingURL=data:application/json;base64,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
